var DealsPaginationEventsHelper, DealsPaginationFooterView, PaginatedDealsListTemplate, PaginatedDealsListView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsPaginationFooterView = require('./pagination_footer');

DealsPaginationEventsHelper = require('../helpers/pagination_events');

PaginatedDealsListTemplate = require('../../paginated_deals_list.html.mustache');

module.exports = PaginatedDealsListView = (function() {
  PaginatedDealsListView.prototype.template = PaginatedDealsListTemplate;

  PaginatedDealsListView.prototype.dealsListId = 'browse-deals';

  function PaginatedDealsListView($el, dealSearch) {
    var currentSearchPage, ref;
    this.$el = $el;
    this.dealSearch = dealSearch;
    this.searchError = bind(this.searchError, this);
    this.searchSuccess = bind(this.searchSuccess, this);
    this.$content = this.$el.find('.content');
    this.prevSearch = null;
    this.footer = new DealsPaginationFooterView();
    this.footer.on('click:paginationLink', this.paginationClickHandler);
    currentSearchPage = (ref = this.dealSearch.params.page) != null ? ref : 1;
    window.onpopstate = _.partial(DealsPaginationEventsHelper.popStateHandler, currentSearchPage);
  }

  PaginatedDealsListView.prototype.render = function() {
    if (this.dealSearch.isEmptySearch()) {
      return;
    }
    this.$content.html(this.toHtml());
    this.postRender();
    return Groupon.BrowseTracking.pageReady();
  };

  PaginatedDealsListView.prototype.postRender = function(overwriteExisting) {
    var element, options;
    if (overwriteExisting == null) {
      overwriteExisting = true;
    }
    this.footer.updatePresenter(this.dealSearch).setElement(this.$el.find('.pagination_footer'));
    if (overwriteExisting) {
      this.footer.render();
    }
    GIG.Utils.truncateElements(element = this.$content, options = {
      watch: false
    });
    return GIG.Tooltip.reloadBindings(element = this.$content, false);
  };

  PaginatedDealsListView.prototype.toHtml = function() {
    return this.template.render(this.present());
  };

  PaginatedDealsListView.prototype.present = function() {
    var hash;
    hash = _.extend({}, this.dealSearch.page, {
      dealsListId: this.dealsListId,
      columnLayoutClass: Groupon.columnLayoutClass,
      cardUIClass: Groupon.cardUIClass
    });
    return hash;
  };

  PaginatedDealsListView.prototype.searchSuccess = function() {
    this.$content.find("#" + this.dealsListId).append(this.dealSearch.page.dealsHtml);
    return this.postRender();
  };

  PaginatedDealsListView.prototype.searchError = function() {
    this.dealSearch = this.prevSearch;
    this.footer.removeLoadingState();
    return this.$el.find('.pagination_footer').remove();
  };

  PaginatedDealsListView.prototype.paginationClickHandler = function(event) {
    return DealsPaginationEventsHelper.updatePageByHref(event.target.href);
  };

  return PaginatedDealsListView;

})();

//# sourceMappingURL=data:application/json;base64,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
